export default {
  emailSenders: [],

  defaultEmailTemplate: null,
};
